import { NgModule } from '@angular/core';
import { ChileanCurrencyPipe } from './chilean-currency.pipe';
import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ChileanCurrencyPipe],
  exports: [
    ChileanCurrencyPipe,
  ],
  providers: [
    CurrencyPipe,
    DecimalPipe,
  ]
})
export class ChileanCurrencyPipeModule { }
